import { ArticleType, RandomGenerator } from '@wix/answers-api';
import { ArticleSearchResultDocumentType, GenAiArticleLink } from '../types';

export const randomArticle = RandomGenerator.article();
const anotherRandomArticle = RandomGenerator.article();

export const genAnswerMock = {
  term: 'payment issue',
  answer: 'To resolve payment issues for your Wix account, follow these steps: <p>1. Check if your payment was declined due to reasons such as: <ul><li>Insufficient funds or expired card</li><li>Invalid card number or reported lost/stolen</li><li>Incorrect CVV code</li><li>Card not valid for online transactions</li></ul></p><p>2. Contact your bank to confirm the correct account details.</p><p>3. Try using a different credit/debit card or a different browser.</p><p>If issues persist, contact Wix support for further assistance <a href="http://www.wix.com/contact" target="_blank">here</a>.</p>',
  usedArticles: [
    'Resolving Payment Issues for Wix Services',
    'Troubleshooting Issues for Accepting Payments'
  ],
  isProhibited: false
};

export const mockArticleLinks: GenAiArticleLink[] = [
  {
    articleId: randomArticle.id,
    articleName: randomArticle.title,
    articleURL: randomArticle.url,
    distance: 0.6736897368796387,
    type: ArticleType.ARTICLE,
    docType: ArticleSearchResultDocumentType.ANSWERS_ARTICLE,
  },
  {
    articleId: anotherRandomArticle.id,
    articleName: anotherRandomArticle.title,
    articleURL: anotherRandomArticle.url,
    distance: 0.368796387,
    type: ArticleType.ARTICLE,
    docType: ArticleSearchResultDocumentType.ANSWERS_ARTICLE,
  },
];

export const mockArticleLinksWithWixDocs: GenAiArticleLink[] = [
  {
    articleId: randomArticle.id,
    articleName: randomArticle.title,
    articleURL: randomArticle.url,
    distance: 0.6736897368796387,
    type: ArticleType.ARTICLE,
    docType: ArticleSearchResultDocumentType.WIX_DOCS_ARTICLE,
  },
  {
    articleId: anotherRandomArticle.id,
    articleName: anotherRandomArticle.title,
    articleURL: anotherRandomArticle.url,
    distance: 0.368796387,
    type: ArticleType.ARTICLE,
    docType: ArticleSearchResultDocumentType.ANSWERS_ARTICLE,
  },
];
